import React from 'react';
import './Loader.css';

/**
 * Reusable Loader component
 * @param {Object} props
 * @param {string} [props.size='medium'] - Size: 'small', 'medium', 'large'
 * @param {boolean} [props.overlay=false] - Show as full-page overlay
 * @param {boolean} [props.contentOverlay=false] - Show as content-area overlay (not full screen)
 * @param {string} [props.text] - Optional loading text
 */
const Loader = ({ size = 'medium', overlay = false, contentOverlay = false, text = 'Loading...' }) => {
  const containerClass = overlay 
    ? 'loader-container loader-overlay' 
    : contentOverlay
    ? 'loader-container loader-content-overlay'
    : 'loader-container';

  const loaderContent = (
    <div className={containerClass}>
      <div className={`loader loader-${size}`}>
        <div className="loader-spinner"></div>
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );

  return loaderContent;
};

export default Loader;
